import React, { PureComponent } from 'react';
import { View } from 'react-native';
import {
    ChangeIndicatedCurrency,
    ChangeIndicatedPercent,
} from '../../../../src/components/common/number';
import DbkText from '@dbk/ui-text';
import {
    NavigationList,
    NavigationListItem,
} from '@dbk/ui-list';
import { PALETTE } from '../../../constants';

class CurrencyList extends PureComponent {
    constructor(props) {
        super(props);
    }

    renderCurrencyList = (currencyList) => {
        return currencyList.map((item, index) => {
            return (

                <NavigationListItem role="none" hasArrow={false}>

                    <View style={{ display: 'flex', flexDirection: 'row', justifyContent: 'space-between', width: '100%', }}>

                        <div className="currency-nav-list-start">
                        <DbkText primary size="large">{item.currency}</DbkText>
                        </div>
                        <div className="currency-nav-list-column">
                            <ChangeIndicatedCurrency
                                value = {item.currencyTRDAmount}
                                onlyNegativeStyling
                            />
                        </div>
                        <div className="currency-nav-list-column">
                            <ChangeIndicatedCurrency
                                value={item.currencyAmtDestCcy}
                                onlyNegativeStyling
                                renderProps={{
                                    color: PALETTE.secondaryActive
                                }}
                            />
                        </div>
                        <div className="currency-nav-list-column market-percent">
                            <ChangeIndicatedPercent
                                value={item.currencyPercentage}
                            />
                        </div>

                    </View>

                </NavigationListItem>
            )

        });


    }
    renderHeader = (referenceCurrency,messages) => {  
        
        return (
            <div className="currency-tab-header-container">
                <DbkText size="large" secondary className="currency-list-header-ccy" tabIndex={0}> {messages['app.common.portfolio.fx.currency']}</DbkText>

                <div className="currency-list-header" tabIndex={0}>
                    <DbkText size="large" secondary className="currency-tab-list-header">{messages['app.portfolio.equassets.mktValue']}</DbkText>
                    <DbkText size="large" secondary className="currency-tab-list-header">{"(" +messages['app.common.portfolio.fx.currency'] +")"}</DbkText>
                </div>
                <div className="currency-list-header-market" tabIndex={0}>
                    <DbkText size="large" secondary className="currency-tab-list-header">{messages['app.portfolio.equassets.mktValue']}</DbkText>
                    <DbkText size="large" secondary className="currency-tab-list-header">{"(in "+ `${referenceCurrency}`+")"}</DbkText>
                </div>
                <DbkText size="large" secondary  className="currency-list-header-prct" tabIndex={0} aria-label={messages['app.common.portfolio.fx.percentage']}>{"%   "}</DbkText>
            </div>);
    }

    render() {

        const currencyExposure = this.props.currencyChartData ? JSON.parse(this.props.currencyChartData) : null;
        const currencyArray = currencyExposure? currencyExposure.currencyAllocation : [];
        const referenceCurrency=this.props.referenceCurrency;
        const messages = this.props.messages; 
        return (

            <div>
                {this.renderHeader(referenceCurrency,messages)}
                <NavigationList style = {{ cursor: 'default'}} hasArrow={false} testID="list">
                    {this.renderCurrencyList(currencyArray)}
                </NavigationList>
            </div>);
    }


}


export default CurrencyList;
